import { clientConfig, getSdk } from "@quickpoint.me/shared";
import { getAuth, getIdToken } from "firebase/auth";
import { GraphQLClient } from "graphql-request";
import { atom, selector } from "recoil";
import { utilityFileNameMessage } from "../lib/codeMessages";
import { OwnerName } from "./authSelectors";
import { StackCfKeyAtom } from "./stackAtoms";
import { StackFileNameSelectorFamily } from "./stackSelectors";

const PublishSelector = selector<boolean>({
  key: "PublishSelector",
  get: async ({ get }) => {

    const ownerName = get(OwnerName);
    const stackCfKey = get(StackCfKeyAtom);
    const stackFileName = get(StackFileNameSelectorFamily(stackCfKey));
    if (!ownerName) return false;

    const user = getAuth().currentUser
    if (!user) return false
    const jwt = await getIdToken(user);

    if (stackFileName in utilityFileNameMessage || ownerName in utilityFileNameMessage) return false;
    if (!stackCfKey || stackCfKey.length === 0) return false;

    const client = new GraphQLClient(clientConfig.gqlGetStack());
    const sdk = getSdk(client);
    const res = await sdk.GetStackIsPublished({ ownerName, stackCfKey, jwt });
    return res.getStackIsPublished;
  },
});

export const PublishAtom = atom<boolean>({
  key: "PublishAtom",
  default: PublishSelector,
});
